<span
  class="sz-num-focal"
  [class.sz-num-focal--xl]="size() === 'xl'"
  [class.sz-num-focal--lg]="size() === 'lg'"
  [class.sz-num-focal--md]="size() === 'md'">
  <span class="sz-num-focal__value">{{ value() }}</span>
  @if (unit(); as unitText) {
    <span class="sz-num-focal__unit">{{ unitText }}</span>
  }
</span>
